import { Row, Col, Form } from 'react-bootstrap';
import Required from '../../../utils/Required';

const CommonUserFields = ({ formData, onChange, userTypes }) => (
  <>
    <Row className="mb-3">
      <Col>
        <Form.FloatingLabel label={<Required>Display Name</Required>} controlId="display-name">
          <Form.Control
            name="displayName"
            value={formData.displayName}
            onChange={onChange}
            maxLength={28}
            placeholder=""
            required
          />
        </Form.FloatingLabel>
      </Col>
      <Col>
        <Form.FloatingLabel label={<Required>User Type</Required>} controlId="user-type">
          <Form.Select
            name="userType"
            value={formData.userType}
            onChange={onChange}
            placeholder=""
            required
          >
            {userTypes.map(type => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </Form.Select>
        </Form.FloatingLabel>
      </Col>
    </Row>
    <Row className="mb-3">
      <Col>
        <Form.FloatingLabel label={<Required>Email Address</Required>} controlId="email-address">
          <Form.Control
            type="email"
            name="emailAddress"
            value={formData.emailAddress}
            onChange={onChange}
            placeholder=""
            required
          />
        </Form.FloatingLabel>
      </Col>
      <Col>
        <Form.FloatingLabel label={<Required>Agency Name</Required>} controlId="agency-name">
          <Form.Control
            name="agencyName"
            value={formData.agencyName}
            onChange={onChange}
            maxLength={64}
            placeholder=""
            required
          />
        </Form.FloatingLabel>
      </Col>
    </Row>
  </>
);

export default CommonUserFields;